import React from 'react';

import { useCurrentUser } from '@klp/auth';
import { BuildingTabs } from '@klp/bygg/classes';
import { ByggCalendarAccess, ByggRoutes } from '@klp/bygg/config';
import { useByggMoterom } from '@klp/bygg/hooks/useByggMoterom';
import { Block } from '@klp/design/Block';
import { Link } from '@klp/design/Link';

type ByggInfoSummaryCalendarProps = {
    byggNummer: string;
};

export const ByggInfoSummaryCalendar = ({
    byggNummer,
}: ByggInfoSummaryCalendarProps) => {
    const { currentUser: user } = useCurrentUser();
    const { byggMoteromList } = useByggMoterom(byggNummer);

    if (byggMoteromList?.length === 0) return null;

    if (!ByggCalendarAccess(user)) return null;

    const title =
        byggMoteromList?.length === 1
            ? byggMoteromList[0].name
            : 'byggCalendar.name';

    if (byggMoteromList?.length <= 3) {
        return (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {byggMoteromList?.map((moterom) => (
                    <Block key={moterom.id}>
                        <Link
                            translation={moterom.name}
                            href={ByggRoutes.single(
                                byggNummer,
                                BuildingTabs.calendar,
                            )}
                            klpTypographyVariant="xsmall"
                            data-testid={`ByggInfoSummary__BuildingCalendar-${moterom.id}`}
                        />
                    </Block>
                ))}
            </>
        );
    }

    return (
        <Block>
            <Link
                translation={title}
                href={ByggRoutes.single(byggNummer, BuildingTabs.calendar)}
                klpTypographyVariant="xsmall"
                data-testid="ByggInfoSummary__BuildingCalendar"
            />
        </Block>
    );
};
